import { render, staticRenderFns } from "./scrollTable.vue?vue&type=template&id=2a8137f2&scoped=true"
import script from "./scrollTable.vue?vue&type=script&lang=js"
export * from "./scrollTable.vue?vue&type=script&lang=js"
import style0 from "./scrollTable.vue?vue&type=style&index=0&id=2a8137f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8137f2",
  null
  
)

export default component.exports